import {ChatItemPartType} from '../../copilot.enums';
import {AssistantChatItem} from '../../copilot.types';
import assistantChatItem from './assistantChatItem';

export default function assistantPlaintextChatItem({
  agent,
  content,
}: {
  agent: string;
  content: string;
}): AssistantChatItem {
  return assistantChatItem({agent, parts: [{type: ChatItemPartType.Plaintext, content}]});
}
